import logo from "../img/logo.jpg";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-panel">
        <div className="logo-box">
          <img src={logo} alt="Charmie's Kastle logo" className="hero-logo" />
        </div>

        <div className="logo-info-card">
          <span className="card-label">Handmade accessories</span>
          <h3>Charmie’s Kastle</h3>
          <p>Custom pieces, charms, keychains, and small 3D printed details.</p>
        </div>
      </div>

      <div className="hero-copy">
        <h1>Small details made to feel personal.</h1>

        <p className="hero-description">
          Charmie’s Kastle creates handmade pieces, custom accessories, and
          small 3D printed items designed for gifts, bags, phones, keys, and
          everyday style.
        </p>

        <div className="hero-actions">
          <a href="#products" className="btn btn-primary">
            View products
          </a>

          <a href="#contact" className="btn btn-light">
            Request custom order
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;